import RawHtmlEditing from './raw-html-editing';
import RawHtmlUI from './raw-html-ui';
import { Plugin } from '@ckeditor/ckeditor5-core';
import './styles.css';
export default class RawHtml extends Plugin {
    static get requires() {
        return [RawHtmlEditing, RawHtmlUI];
    }
}
